import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslations } from "../../../providers/useTranslations";
import styles from "./CustomMonthCaption.module.scss";
export const CustomMonthCaption = (props) => {
    const { __ } = useTranslations();
    const monthIndex = props.calendarMonth.date.getMonth();
    return _jsx("div", { className: styles.monthCaption, children: __(`daypicker.month.${monthIndex + 1}`) });
};
//# sourceMappingURL=CustomMonthCaption.js.map